<template>
    <div class="d-flex flex-column overflow-hidden">
        <b-form
            v-on:submit.prevent="$_onSubmit"
            class="d-flex flex-column overflow-hidden"
        >
            <div class="scrollable mb-3">
                <b-container>
                    <category
                        :categories="categories"
                        :inputFields="inputFields"
                        id="stuf"
                        @onChange="$_validateDate($event)"
                        :invalidFieldValueErrorMessage="
                            invalidFieldValueErrorMessage
                        "
                    />
                </b-container>
            </div>
            <div v-if="invalidForm" class="errormsg px-4 mb-2">
                {{ invalidFormErrorMessage }}
            </div>
            <b-container>
                <b-row>
                    <b-col class="text-right pb-4">
                        <b-button variant="primary" type="submit">
                            <span> {{ $t('searchButtonText') }} </span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
    </div>
</template>

<script>
    import { FIELD_TYPE } from '../../../constants';
    import { createStufBgQueryObject } from '../../../services/utilities/apis/stuf';
    import { validateDate } from '../../../services/utilities/validator';
    import Category from './ApiCategory.vue';

    const WILDCARD_SYMBOL = '*';
    export default {
        components: { category: Category },
        data() {
            return {
                invalidFieldValueErrorMessage: '',
                invalidForm: false,
                invalidFormErrorMessage: '',
                categories: [
                    {
                        label: this.$t('stuf.searchCat1'),
                        category: 1,
                        expanded: true
                    },
                    {
                        label: this.$t('stuf.searchCat2'),
                        category: 2,
                        expanded: false
                    },
                    {
                        label: this.$t('stuf.searchCat3'),
                        category: 3,
                        expanded: false
                    }
                ],
                inputFields: [
                    {
                        label: this.$t('stuf.burgerservicenummer'),
                        key: 'Bsn',
                        value: '',
                        category: 1,
                        maxlength: 9,
                        pattern: '[0-9]{8}([0-9]{1})?',
                        title: '8 of 9 cijfers'
                    },
                    {
                        label: this.$t('stuf.geslachtsnaam'),
                        key: 'Geslachtsnaam',
                        value: '',
                        category: 1,
                        maxlength: 100
                    },
                    {
                        label: this.$t('stuf.voorvoegsel'),
                        key: 'VoorvoegselGeslachtsnaam',
                        value: '',
                        category: 1,
                        maxlength: 100
                    },
                    {
                        label: this.$t('stuf.voorletters'),
                        key: 'Voorletters',
                        value: '',
                        category: 1,
                        maxlength: 100
                    },
                    {
                        label: `${this.$t('stuf.geslachtsaanduiding')} (M/V/O)`,
                        key: 'Geslachtsaanduiding',
                        value: '',
                        category: 3,
                        maxlength: 100
                    },
                    {
                        label: `${this.$t('stuf.burgerlijkeStaat')} (1-9)`,
                        key: 'BurgerlijkeStaat',
                        value: '',
                        category: 3,
                        maxlength: 100
                    },
                    {
                        label: `${this.$t('stuf.geboortedatum')} (dd-mm-jjjj)`,
                        key: 'GeboorteDatum',
                        value: '',
                        category: 3,
                        maxlength: 10,
                        type: FIELD_TYPE.DATE
                    },
                    {
                        label: this.$t('stuf.geboorteplaats'),
                        key: 'Geboorteplaats',
                        value: '',
                        category: 3,
                        maxlength: 100
                    },
                    {
                        label: `${this.$t('stuf.overlijdensdatum')} (dd-mm-jjjj)`,
                        key: 'Overlijdensdatum',
                        value: '',
                        category: 3,
                        maxlength: 10,
                        type: FIELD_TYPE.DATE
                    },
                    {
                        label: this.$t('stuf.overlijdenplaats'),
                        key: 'Overlijdenplaats',
                        value: '',
                        category: 3,
                        maxlength: 100
                    },
                    {
                        label: this.$t('stuf.straatnaam'),
                        key: 'streetName',
                        value: '',
                        category: 2,
                        maxlength: 100
                    },
                    {
                        label: this.$t('stuf.postcode'),
                        key: 'postCode',
                        value: '',
                        category: 2,
                        maxlength: 6,
                        pattern: '[1-9][0-9]{3}(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}',
                        title: 'formaat: 1234ab of 1234AB'
                    },
                    {
                        label: this.$t('stuf.huisnummer'),
                        key: 'huisNummer',
                        value: null,
                        category: 2,
                        maxlength: 10,
                        type: FIELD_TYPE.NUMERIC
                    },
                    {
                        label: this.$t('stuf.huisletter'),
                        key: 'huisLetter',
                        value: WILDCARD_SYMBOL,
                        category: 2,
                        maxlength: 100
                    },
                    {
                        label: this.$t('stuf.huisnummerToevoeging'),
                        key: 'huisNummerToevoeging',
                        value: WILDCARD_SYMBOL,
                        category: 2,
                        maxlength: 4
                    },
                    {
                        label: this.$t('stuf.woonplaats'),
                        key: 'city',
                        value: '',
                        category: 2,
                        maxlength: 100
                    }
                ]
            };
        },
        methods: {
            $_onSubmit() {
                let query = {};
                // Only add fields that have a value
                this.inputFields.forEach((item) => {
                    const value =
                        typeof item.value === 'string'
                            ? item.value.trim()
                            : item.value;
                    if (
                        value !== null &&
                        value !== '' &&
                        this.categories[item.category - 1].expanded
                    ) {
                        query[item.key] = value;
                    }
                });
                if (this.$_isValidForm(query)) {
                    this.$store.commit('CLEAR_SELECTIONS');
                    this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_START');
                    this.$store.dispatch('getNaturalPersons', {
                        name: 'GetNaturalPersons',
                        data: createStufBgQueryObject(query),
                        title: this.$t('stuf.naturalPerson')
                    });
                    this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_END');
                }
            },
            $_isValidForm(query) {
                this.invalidForm = false;
                this.invalidFormErrorMessage = '';

                if (this.$_hasMissingSearchFields(query)) {
                    this.invalidFormErrorMessage = this.$t(
                        'stuf.missingSearchFields'
                    );
                    this.invalidForm = true;
                    return false;
                }

                if (this.$_hasInvalidStateFields(query)) {
                    this.invalidFormErrorMessage = this.$t(
                        'incorrectInputAllFields'
                    );
                    this.invalidForm = true;
                    return false;
                }
                return true;
            },
            $_hasMissingSearchFields(query) {
                return (
                    !query['Bsn'] &&
                    !query['Geslachtsnaam'] &&
                    !query['GeboorteDatum'] &&
                    !query['Overlijdensdatum'] &&
                    !(query['streetName'] && query['huisNummer']) &&
                    !(query['postCode'] && query['huisNummer'])
                );
            },
            $_hasInvalidStateFields(query) {
                const invalidFields = this.inputFields.filter(
                    ({ state }) => state === false
                );
                return invalidFields.length > 0;
            },
            $_validateDate(field) {
                if (field.type === FIELD_TYPE.DATE) {
                    if (field.value.length > 0) {
                        field.state = validateDate(field.value);
                    } else {
                        field.state = null;
                    }
                    this.invalidFieldValueErrorMessage =
                        field.state === true || field.state === null
                            ? ''
                            : this.$t('labelInvalidDate');
                }
            }
        }
    };
</script>

<style scoped lang="scss">
.scrollable {
    overflow-y: auto;
}
</style>
